// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepBar {
  width: 100%;
  background: var(--clr-primary-dark);
  position: sticky;
  padding: 0.75em 0;
  color: var(--clr-light);
  bottom: 0;
  z-index: 100;
  margin-top: 5rem;
}

.stepBar__steps {
  /* display: flex; */
  padding: 0 1em;
  display: grid;
  gap: 1rem;
  position: relative;
  overflow-x: scroll;
  scrollbar-width: none;
  grid-template-columns: repeat(6, minmax(10rem, 1fr));
  /* gap: 1rem; */
}

.stepBar__steps::-webkit-scrollbar {
  display: none;
}

.stepBar::before,
.stepBar::after {
  content: "";
  position: absolute;
  width: 1rem;
  height: 80%;
  bottom: 0.75rem;
}

.stepBar::before {
  left: 10%;
  transform: translate(-10%);
  z-index: 1;
  background: linear-gradient(-270deg, #622e2d 0%, rgba(98, 46, 45, 0) 100%);
}

.stepBar::after {
  right: 10%;
  transform: translate(10%);
  background: linear-gradient(270deg, #622e2d 0%, rgba(98, 46, 45, 0) 100%);
}

.stepBar__step.completed {
  background: var(--clr-primary);
  border: 0.1rem solid var(--clr-primary);
}

.stepBar__step.loading {
  background: var(--clr-light);
  border: 0.1rem solid var(--clr-light);
  color: var(--clr-dark);
}

.stepBar__step {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em 0.5em;
  border: 0.1rem dashed var(--clr-light);
  border-radius: 1em;
  cursor: pointer;
  font-size: 0.8rem;
  width: 100%;
}

.stepBar__step span {
  display: block;
  margin-left: 0.5rem;
}

.stepBar__step.stepBar__step.completed span {
  margin-left: 1rem;
}

.stepBar__clockIcon {
  width: 100%;
  max-width: 1.5rem;
}

@media (min-width: 992px) {
  .stepBar {
    padding: 1.5em 0;
  }

  .stepBar__step {
    padding: 1.5em 1em;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StepBar/StepBar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".stepBar {\n  width: 100%;\n  background: var(--clr-primary-dark);\n  position: sticky;\n  padding: 0.75em 0;\n  color: var(--clr-light);\n  bottom: 0;\n  z-index: 100;\n  margin-top: 5rem;\n}\n\n.stepBar__steps {\n  /* display: flex; */\n  padding: 0 1em;\n  display: grid;\n  gap: 1rem;\n  position: relative;\n  overflow-x: scroll;\n  scrollbar-width: none;\n  grid-template-columns: repeat(6, minmax(10rem, 1fr));\n  /* gap: 1rem; */\n}\n\n.stepBar__steps::-webkit-scrollbar {\n  display: none;\n}\n\n.stepBar::before,\n.stepBar::after {\n  content: \"\";\n  position: absolute;\n  width: 1rem;\n  height: 80%;\n  bottom: 0.75rem;\n}\n\n.stepBar::before {\n  left: 10%;\n  transform: translate(-10%);\n  z-index: 1;\n  background: linear-gradient(-270deg, #622e2d 0%, rgba(98, 46, 45, 0) 100%);\n}\n\n.stepBar::after {\n  right: 10%;\n  transform: translate(10%);\n  background: linear-gradient(270deg, #622e2d 0%, rgba(98, 46, 45, 0) 100%);\n}\n\n.stepBar__step.completed {\n  background: var(--clr-primary);\n  border: 0.1rem solid var(--clr-primary);\n}\n\n.stepBar__step.loading {\n  background: var(--clr-light);\n  border: 0.1rem solid var(--clr-light);\n  color: var(--clr-dark);\n}\n\n.stepBar__step {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1em 0.5em;\n  border: 0.1rem dashed var(--clr-light);\n  border-radius: 1em;\n  cursor: pointer;\n  font-size: 0.8rem;\n  width: 100%;\n}\n\n.stepBar__step span {\n  display: block;\n  margin-left: 0.5rem;\n}\n\n.stepBar__step.stepBar__step.completed span {\n  margin-left: 1rem;\n}\n\n.stepBar__clockIcon {\n  width: 100%;\n  max-width: 1.5rem;\n}\n\n@media (min-width: 992px) {\n  .stepBar {\n    padding: 1.5em 0;\n  }\n\n  .stepBar__step {\n    padding: 1.5em 1em;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
